/** @jsx jsx */
import React, {
  ReactNode,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { jsx } from '@emotion/core';
import styles from './styles';
import { composeStyles } from 'features/Theme';

export interface PropTypes {
  children: ReactNode;
}

const StickyFooter: React.FC<PropTypes> = props => {
  const { children } = props;

  const [isPinned, setIsPinned] = useState(false);

  const callbackFunct: IntersectionObserverCallback = useCallback(
    entries => {
      const [entry] = entries;
      if (entry.intersectionRatio < 1) {
        setIsPinned(false);
      } else {
        setIsPinned(true);
      }
    },
    [setIsPinned],
  );
  const options = {
    threshold: 1,
  };

  const stickyRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(callbackFunct, options);

    if (stickyRef.current)
      observer.observe(stickyRef.current || new HTMLElement());

    return () => observer.disconnect();
  }, [options, callbackFunct]);

  return (
    <div
      css={composeStyles([
        styles.container,
        isPinned ? null : styles.notPinnedFooter,
      ])}
      ref={stickyRef}
    >
      {children}
    </div>
  );
};

export default StickyFooter;
